import type { Box } from './sketchLayout';

export const pill = (box: Box): string => {
  const r = box.h / 2;
  return `M${box.x + r} ${box.y} H${box.x + box.w - r} a${r} ${r} 0 0 1 0 ${box.h} H${box.x + r} a${r} ${r} 0 0 1 0 ${-box.h} Z`;
};

export const roundedRect = ({ x, y, w, h }: Box, r = 14): string =>
  `M${x + r} ${y} H${x + w - r} q${r} 0 ${r} ${r} V${y + h - r} q0 ${r} ${-r} ${r} H${x + r} q${-r} 0 ${-r} ${-r} V${y + r} q0 ${-r} ${r} ${-r} Z`;

export const knob = (cx: number, cy: number, r: number) =>
  `M${cx + r} ${cy} a${r} ${r} 0 1 1 ${-2 * r} 0 a${r} ${r} 0 1 1 ${2 * r} 0`;
